import React from 'react'
import { tagContext } from './context';

const useTag = () => {
  const {
    tags,
    tagOptions
  } = React.useContext(tagContext);
  return {
    tags,
    tagOptions
  };
}

export { useTag }
